import React from "react";
import { BookOpen, Microscope, Heart } from "lucide-react";

const pillars = [
  {
    icon: BookOpen,
    title: "Un libro ilustrado en acuarela",
    desc: "140 páginas a todo color con ilustraciones de cerca de 50 especies de tiburones, fichas científicas sobre su biología, hábitat, conservación y amenazas, más cinco óleos originales de la autora.",
  },
  {
    icon: Microscope,
    title: "Divulgación con rigor",
    desc: "Una mezcla de ciencia popular, testimonio personal y expresión artística. Contenidos supervisados por la investigadora Remedios Cabrera (Universidad de Cádiz) y con la colaboración de referentes como Gador Muntaner.",
  },
  {
    icon: Heart,
    title: "Beneficios para Oceana",
    desc: "Los beneficios del libro se donan a Oceana, la mayor organización mundial para la protección de los océanos y referente en la lucha contra el finning en Europa.",
  },
];

export default function About() {
  return (
    <section
      id="about"
      data-testid="about-section"
      className="relative py-24 sm:py-32 bg-slate-950/50"
    >
      <div className="max-w-4xl mx-auto px-6 sm:px-8 lg:px-12">
        <div>
          <span className="text-xs uppercase tracking-[0.2em] font-medium text-cyan-400">
            Sobre el proyecto
          </span>
          <h2 className="font-heading text-4xl sm:text-5xl font-bold tracking-tight mt-4 mb-6 leading-[1.05]">
            Un libro para entender por qué <span className="text-gradient">los tiburones nos importan a todos</span>.
          </h2>
          <p className="text-lg text-slate-300 leading-relaxed mb-5">
            <span className="text-white font-semibold">"Sin aletas no hay paraíso"</span> es un libro
            ilustrado de divulgación científica con mirada artística, escrito en primera persona. Alerta
            sobre la desaparición de los tiburones, explica su papel esencial en el equilibrio del
            océano y desmonta los prejuicios que pesan sobre ellos.
          </p>
          <p className="text-slate-400 leading-relaxed mb-10">
            No es un tratado académico ni una obra de ficción: es un proyecto que combina ciencia,
            ilustración y compromiso para que cualquier persona pueda entender por qué proteger a los
            tiburones es proteger el planeta.
          </p>

          <div className="space-y-5">
            {pillars.map((p, i) => {
              const Icon = p.icon;
              return (
                <div
                  key={i}
                  data-testid={`pillar-${i}`}
                  className="flex gap-5 items-start group"
                >
                  <div className="shrink-0 w-12 h-12 rounded-2xl bg-cyan-500/10 border border-cyan-400/30 flex items-center justify-center group-hover:bg-cyan-500/20 transition">
                    <Icon className="w-5 h-5 text-cyan-400" />
                  </div>
                  <div>
                    <h3 className="font-heading font-semibold text-lg text-white mb-1">
                      {p.title}
                    </h3>
                    <p className="text-sm text-slate-400 leading-relaxed">
                      {p.desc}
                    </p>
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
}
